import React from 'react';
import { identity } from 'ramda';
import { getClassNames } from 'js/utils/classNames.util';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';

import style from './Icon.scss';

/**
 * @param props {Object}
 * @param [props.type] {string}
 * @param [props.className] {string}
 * @param [props.disabled] {boolean}
 * @param [props.onClick] {Function}
 * @param [props.role] {string}
 */
export const Icon = ({ type = '', className = '', disabled = false, onClick, role, ...other }) => {
    const classes = getClassNames([
        style.common,
        disabled && style.disabled,
        type && getClassNames([style.icon, style[type]]),
        className
    ]);

    return (
        onClick
            ? (
                <AccessibilityElement
                    role={role}
                    inline={true}
                    onClick={disabled ? identity : onClick}
                    className={classes}
                    {...other}
                />
            )
            : <span className={classes} {...other} />
    );
};
